import axios from 'axios';
import { ssobase } from '@/config';

export default {
  async getMemberSourceSetting(params) {
    try {
      const res = await axios.post(`${ssobase}get/api/v1/member-source-setting`, {}, { params });
      return res.data;
    } catch (err) {
      return err.response;
    }
  },
  async getMemberSourcePair(params) {
    try {
      const res = await axios.post(`${ssobase}get/api/v1/member-source/pair`, {}, { params });
      return res.data;
    } catch (err) {
      return err.response;
    }
  },
  async getBrand(params) {
    try {
      const res = await axios.post(`${ssobase}get/api/v1/brand`, {}, { params });
      return res.data;
    } catch (err) {
      return err.response;
    }
  },
  async postLogin(body) {
    try {
      const res = await axios.post(`${ssobase}post/api/v1/login`, body);
      return res.data;
    } catch (err) {
      return err.response;
    }
  },
  async postDigest(body) {
    try {
      const res = await axios.post(`${ssobase}post/api/v1/digest`, body);
      return res.data;
    } catch (err) {
      return err.response;
    }
  },
  async postAccesstokenEditcode(body, headers) {
    try {
      const res = await axios.post(`${ssobase}post/api/v1/accesstoken/editcode`, body, { headers });
      return res.data;
    } catch (err) {
      return err.response;
    }
  },
  async postAccesstokenCode(body, headers) {
    try {
      const res = await axios.post(`${ssobase}post/api/v1/accesstoken/code`, body, { headers });
      return res.data;
    } catch (err) {
      return err.response;
    }
  },
  async getCompanyPermission(params) {
    try {
      const res = await axios.post(`${ssobase}get/api/v1/company-permission`, {}, { params });
      return res.data;
    } catch (err) {
      return err.response;
    }
  },
  async getProfileSetting(params) {
    try {
      const res = await axios.post(`${ssobase}get/api/v1/profile-setting`, {}, { params });
      return res.data;
    } catch (err) {
      return err.response;
    }
  },
  async getCountrys() {
    try {
      const res = await axios.post(`${ssobase}get/api/v1/countrys`, {});
      return res.data;
    } catch (err) {
      return err.response;
    }
  },
  async getzipcode() {
    try {
      const res = await axios.post(`${ssobase}get/api/v1/getzipcode`, {});
      return res.data;
    } catch (err) {
      return err.response;
    }
  },
  async postWording(body) {
    try {
      const res = await axios.post(`${ssobase}post/api/v1/wording`, body);
      return res.data;
    } catch (err) {
      return err.response;
    }
  },
  async postVerifyCode(body) {
    try {
      const res = await axios.post(`${ssobase}post/api/v1/verify-code`, body);
      return res.data;
    } catch (err) {
      return err.response;
    }
  },
  async postVerifyCodeVerifier(body) {
    try {
      const res = await axios.post(`${ssobase}post/api/v1/verifycode-verifier`, body);
      return res.data;
    } catch (err) {
      return err.response;
    }
  },
  async postMobileVerifyCode(body) {
    try {
      const res = await axios.post(`${ssobase}post/api/v1/mobile-verify-code`, body);
      return res.data;
    } catch (err) {
      return err.response;
    }
  },
  async getMobileVerifySetting(params) {
    try {
      const res = await axios.post(`${ssobase}get/api/v1/MobileVerifySetting`, {}, { params });
      return res.data;
    } catch (err) {
      return err.response;
    }
  },
  async postMobileVerifycodeVerifier(body) {
    try {
      const res = await axios.post(`${ssobase}post/api/v1/mobile-verifycode-verifier`, body);
      return res.data;
    } catch (err) {
      return err.response;
    }
  },
  async postDynamicLogin(body) {
    try {
      const res = await axios.post(`${ssobase}post/api/v1/dynamic-login`, body);
      return res.data;
    } catch (err) {
      return err.response;
    }
  },
  async getProfileSettingByMemberSource(params) {
    try {
      const res = await axios.post(`${ssobase}get/api/v1/profile-setting-by-membersource`, {}, { params });
      return res.data;
    } catch (err) {
      return err.response;
    }
  },
  // 取得指定的頁面設定
  async getPageSetting(body) {
    try {
      const res = await axios.post(`${ssobase}post/api/v1/setting/basic-query/page`, body);
      return res.data;
    } catch (err) {
      return err.response;
    }
  },
  async getLineProfile(body) {
    try {
      const res = await axios.post(`${ssobase}post/api/v1/line/profile`, body);
      return res.data;
    } catch (err) {
      return err.response;
    }
  }
};
